/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most-used words ranked`)
};

const es_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabras más usadas ordenadas`)
};

const de_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgenutzte Wörter im Ranking`)
};

const nl_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest gebruikte woorden gerangschikt`)
};

const fr_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots les plus utilisés classés`)
};

const it_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parole più utilizzate classificate`)
};

const pt_br2_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras mais usadas classificadas`)
};

const pt_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras mais utilizadas classificadas`)
};

const ja_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も使用された単語のランキング`)
};

const zh_wf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按使用频率排名的常用词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_nav_main_desc", locale)
	if (locale === "en") return en_wf_nav_main_desc(inputs)
	if (locale === "es") return es_wf_nav_main_desc(inputs)
	if (locale === "de") return de_wf_nav_main_desc(inputs)
	if (locale === "nl") return nl_wf_nav_main_desc(inputs)
	if (locale === "fr") return fr_wf_nav_main_desc(inputs)
	if (locale === "it") return it_wf_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_wf_nav_main_desc(inputs)
	if (locale === "pt") return pt_wf_nav_main_desc(inputs)
	if (locale === "ja") return ja_wf_nav_main_desc(inputs)
	return zh_wf_nav_main_desc(inputs)
};